import toast from 'react-hot-toast';
import {
  ValueOrFunction,
  Toast,
  Renderable,
  ToastOptions,
} from 'react-hot-toast/dist/core/types';

const normalToast = (
  message?: ValueOrFunction<Renderable, Toast>,
  options?: ToastOptions,
) => {
  if (!message) {
    return;
  }
  toast(message, {
    ...options,
    style: { fontSize: '14px' },
  });
};

const errorToast = (
  message?: ValueOrFunction<Renderable, Toast>,
  options?: ToastOptions,
) => {
  if (!message) {
    return;
  }
  toast.error(message, {
    ...options,
    style: { fontSize: '14px' },
  });
};

const successToast = (
  message?: ValueOrFunction<Renderable, Toast>,
  options?: ToastOptions,
) => {
  if (!message) {
    return;
  }
  toast.success(message, {
    style: { fontSize: '14px' },
    ...options,
  });
};
export { normalToast, errorToast, successToast };
